import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ad-box" }, null, -1)
const _hoisted_3 = { class: "open-key" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px"} }, "点击开门", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "ad-box",
  style: {"height":"55vw"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"red","font-size":"14px"} }, "本店已启动白名单，您并非本店白名单用户，开门需要向店主申请，是否申请？")
], -1)

import bannerImg from '@/assets/images/banner.jpg';
import { AxiosError } from 'axios';
import { ref } from 'vue';
import { useApi } from '@/hooks/useApi';
import { useLoading } from '@/hooks/useLoading';
import { useBaseUserStore, useRoute, useRouter } from 'juou-managebase-ui';
import { useToast } from '@/hooks/useToast';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const dialogVisible = ref(false);
const applyDialogVisible = ref(false);
const applyStoreId = ref<number>();

const loading = useLoading();
const toast = useToast();

const route = useRoute();
const router = useRouter();

const { query } = route;
const baseUserStore = useBaseUserStore();

const onUnlock = async() => {
  if (!query.code || !query.appid) {
    console.log(query);
    toast.show('请通过微信扫码开门');
    return;
  }

  if (!baseUserStore.token) {
    dialogVisible.value = true;
    return;
  }

  try {
    loading.show('开锁中...');
    const res = await useApi().storeApi.opendoorByCodestore({
      code: query.code as string,
    }, {
      headers: {
        appid: query.appid as string,
      },
    });
    console.log(res);
    router.push({
      name: 'success',
      state: {
        data: res?.data?.data,
      },
    });
  } catch (error: any) {
    if (!error) {
      return;
    }

    if (error instanceof AxiosError) {
      toast.show('开门失败');
      return;
    }

    console.log(error);

    // 需要申请
    if (error?.data?.needApplay && error?.data?.storeId) {
      applyStoreId.value = error?.data?.storeId;
      applyDialogVisible.value = true;
      return;
    }

    toast.show('开门失败!');
  } finally {
    loading.hide();
  }
};

const handleApplay = async() => {
  try {
    if (!applyStoreId.value || !query.appid) {
      toast.show('未获取到门店信息!');
      return;
    }
    loading.show('提交中...');
    await useApi().whiteAccountApi.applywhiteAccount(applyStoreId.value, {
      headers: {
        appid: query.appid as string,
      },
    });
    applyDialogVisible.value = false;
    toast.show('已提交申请!');
  } catch (error) {
    if (!error) {
      throw error;
    }
    toast.show('申请失败!');
    throw error;
  } finally {
    loading.hide();
  }
};

const handleApplyBeforeClose = async(event: any) => {
  console.log(event);
  if (event !== 'ok') {
    return true;
  }
  await handleApplay();
  return true;
};

const handleToBindWx = () => {
  router.push(`/bindwx?appid=${query.appid}&state=${encodeURI('授权成功，请重新扫码')}`);
};


const init = () => {
  if (!query.appid) {
    alert('请通过扫码进入');
    window.close();
    return;
  }
  onUnlock();
};

init();


return (_ctx: any,_cache: any) => {
  const _component_IconFont = _resolveComponent("IconFont")!
  const _component_nut_button = _resolveComponent("nut-button")!
  const _component_nut_cell = _resolveComponent("nut-cell")!
  const _component_nut_dialog = _resolveComponent("nut-dialog")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { class: "index-home" }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _unref(bannerImg),
        class: "radius",
        style: {"width":"100%","margin-bottom":"2px"}
      }, null, 8, _hoisted_1),
      _hoisted_2,
      _createVNode(_component_nut_cell, { class: "cell" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "open-key-bt",
              onClick: onUnlock
            }, [
              _createVNode(_component_IconFont, {
                "font-class-name": "iconfont",
                "class-prefix": "icon",
                class: "open-key-icon",
                size: 32,
                name: "michi"
              }),
              _hoisted_4
            ]),
            _createVNode(_component_nut_button, {
              type: "primary",
              onClick: onUnlock,
              class: "openbt"
            }, {
              default: _withCtx(() => [
                _createTextVNode("一键开门")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _hoisted_5,
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(loading).cnt), { style: {"height":"100vh","position":"fixed"} })),
      _createVNode(_component_nut_dialog, {
        title: "需要授权",
        content: "一键开门需要授权登录后才能试用，是否跳转授权？",
        visible: dialogVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
        onOk: handleToBindWx
      }, null, 8, ["visible"]),
      _createVNode(_component_nut_dialog, {
        title: "申请开门",
        visible: applyDialogVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((applyDialogVisible).value = $event)),
        "before-close": handleApplyBeforeClose
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["visible"]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(loading).cnt))),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(toast).cnt)))
    ]),
    _: 1
  }))
}
}

})